var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../actions';
import * as c from '../constantes';
import * as Util from '../../util';
import Lapiz from '../herramientas/lapiz';
import Marcador from '../herramientas/marcador';
import Borrador from '../herramientas/borrador';
import { getColorLapiz, getGrosorLapiz, getColorMarcador, getGrosorMarcador, getAlphaMarcador, getGrosorBorrador, getHerramienta, getDataURL } from '../selectors';

var crearHerramienta = function crearHerramienta(_ref) {
  var herramienta = _ref.herramienta,
      colorLapiz = _ref.colorLapiz,
      grosorLapiz = _ref.grosorLapiz,
      colorMarcador = _ref.colorMarcador,
      grosorMarcador = _ref.grosorMarcador,
      alphaMarcador = _ref.alphaMarcador,
      grosorBorrador = _ref.grosorBorrador;

  switch (herramienta) {
    case c.HERRAMIENTA_MARCADOR:
      return new Marcador(colorMarcador, grosorMarcador, alphaMarcador);

    case c.HERRAMIENTA_BORRADOR:
      return new Borrador(grosorBorrador);

    case c.HERRAMIENTA_LAPIZ:
    default:
      return new Lapiz(colorLapiz, grosorLapiz);
  }
};

var Lienzo = (_temp = _class = function (_Component) {
  _inherits(Lienzo, _Component);

  Lienzo.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    return {
      herramienta: crearHerramienta(props, state)
    };
  };

  function Lienzo(props) {
    _classCallCheck(this, Lienzo);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.screenToCanvas = function (_ref2) {
      var x = _ref2.x,
          y = _ref2.y;
      var canvas = _this.canvasRef.current;
      var canvasScreen = canvas.getBoundingClientRect();
      var scrollTop = document.body.scrollTop;
      return {
        x: (x - canvasScreen.left) / (canvasScreen.width / canvas.width),
        y: (y - canvasScreen.top - scrollTop) / (canvasScreen.height / canvas.height)
      };
    };

    _this.pintarDataURL = function () {
      if (!_this.props.dataURL) {
        return;
      }

      var img = new Image();

      var loadImg = function loadImg() {
        var ctx = _this.state.ctx;
        var _this$props$resolucio = _this.props.resolucion,
            w = _this$props$resolucio.w,
            h = _this$props$resolucio.h;
        var sw = w - 1;
        var sh = h - 1;
        img.removeEventListener('load', loadImg);
        ctx.globalCompositeOperation = 'source-over';
        ctx.clearRect(0, 0, w, h);
        ctx.drawImage(img, 0, 0, sw, sh, 0, 0, sw, sh);
      };

      img.addEventListener('load', loadImg);
      img.src = _this.props.dataURL;
    };

    _this.handleTouchEnd = function (e) {
      e.preventDefault();
      var ctx = _this.state.ctx;

      if (!ctx) {
        return;
      }

      var touch = e.changedTouches[0];

      var _this$screenToCanvas = _this.screenToCanvas({
        x: touch.clientX,
        y: touch.clientY
      }),
          x = _this$screenToCanvas.x,
          y = _this$screenToCanvas.y;

      _this.handleUp(ctx, x, y);
    };

    _this.handleMouseUp = function (e) {
      var ctx = _this.state.ctx;

      if (!ctx) {
        return;
      }

      e.preventDefault();

      var _this$screenToCanvas2 = _this.screenToCanvas({
        x: e.clientX,
        y: e.clientY
      }),
          x = _this$screenToCanvas2.x,
          y = _this$screenToCanvas2.y;

      _this.handleUp(ctx, x, y);
    };

    _this.notificarCambios = function () {
      var dataURL = _this.canvasRef.current.toDataURL();

      _this.props.dispatch(actions.notificarCambios(dataURL));
    };

    _this.handleUp = function (ctx, x, y) {
      var herramienta = _this.state.herramienta; // this.getHerramienta();

      if (!herramienta) {
        return;
      }

      herramienta.up(ctx, x, y, _this.notificarCambios);
    };

    _this.handleTouchStart = function (e) {
      var ctx = _this.state.ctx;

      if (!ctx) {
        return;
      }

      e.preventDefault();

      var _this$screenToCanvas3 = _this.screenToCanvas({
        x: e.changedTouches[0].clientX,
        y: e.changedTouches[0].clientY
      }),
          x = _this$screenToCanvas3.x,
          y = _this$screenToCanvas3.y;

      _this.handleDown(ctx, x, y);
    };

    _this.handleMouseDown = function (e) {
      var ctx = _this.state.ctx;

      if (!ctx) {
        return;
      }

      e.preventDefault();

      var _this$screenToCanvas4 = _this.screenToCanvas({
        x: e.clientX,
        y: e.clientY
      }),
          x = _this$screenToCanvas4.x,
          y = _this$screenToCanvas4.y;

      _this.handleDown(ctx, x, y);
    };

    _this.handleDown = function (ctx, x, y) {
      var herramienta = _this.state.herramienta; // this.getHerramienta();

      if (!herramienta) {
        return;
      }

      _this.lastX = x;
      _this.lastY = y;
      herramienta.down(ctx, x, y, _this.props.dataURL);
    };

    _this.handleTouchMove = function (e) {
      var ctx = _this.state.ctx;

      if (!ctx || e.changedTouches.length !== 1) {
        return;
      }

      e.preventDefault();

      var _this$screenToCanvas5 = _this.screenToCanvas({
        x: e.changedTouches[0].clientX,
        y: e.changedTouches[0].clientY
      }),
          x = _this$screenToCanvas5.x,
          y = _this$screenToCanvas5.y;

      _this.handleMove(ctx, x, y);
    };

    _this.handleMouseMove = function (e) {
      var ctx = _this.state.ctx;

      if (!ctx || e.buttons !== 1) {
        return;
      }

      e.preventDefault();

      var _this$screenToCanvas6 = _this.screenToCanvas({
        x: e.clientX,
        y: e.clientY
      }),
          x = _this$screenToCanvas6.x,
          y = _this$screenToCanvas6.y;

      _this.handleMove(ctx, x, y);
    };

    _this.handleMove = function (ctx, x, y) {
      var herramienta = _this.state.herramienta; // this.getHerramienta();

      if (!herramienta) {
        return;
      }

      _this.lastX = x;
      _this.lastY = y;
      herramienta.move(ctx, x, y);
    };

    _this.state = {
      ctx: null,
      herramienta: null
    };
    _this.canvasRef = React.createRef();
    return _this;
  }

  Lienzo.prototype.componentDidUpdate = function componentDidUpdate() {
    if (!this.state.ctx) {
      return;
    }

    this.pintarDataURL();
  };

  Lienzo.prototype.componentDidMount = function componentDidMount() {
    var ctx = this.canvasRef.current.getContext('2d');
    this.setState({
      ctx: ctx
    }, this.pintarDataURL);
  };

  Lienzo.prototype.getClasesLienzo = function getClasesLienzo() {
    var herramienta = this.state.herramienta; // this.getHerramienta();     

    if (herramienta) {
      return 'lienzo ' + herramienta.getCursor();
    }

    return 'lienzo';
  }; // makeCursor (color, grosor) {
  //     // create off-screen canvas
  //     var cursor = document.createElement('canvas'),
  //         ctx = cursor.getContext('2d');
  //     cursor.width = 16;
  //     cursor.height = 16;
  //     // draw some shape for sake of demo
  //     ctx.strokeStyle = color;
  //     ctx.lineWidth = 2 + (grosor / 8);
  //     ctx.moveTo(2, 10);
  //     ctx.lineTo(2, 2);
  //     ctx.lineTo(10, 2);
  //     ctx.moveTo(2, 2);
  //     ctx.lineTo(30, 30)    
  //     ctx.stroke();
  //     // set image as cursor (modern browsers can take PNGs as cursor).
  //     return 'url(' + cursor.toDataURL() + '), auto';
  // }


  Lienzo.prototype.render = function render() {
    var _props = this.props,
        resolucion = _props.resolucion,
        _props$style = _props.style,
        style = _props$style === undefined ? {} : _props$style;
    var eventos = Util.is_touch_device() ? {
      onTouchStart: this.handleTouchStart,
      onTouchMove: this.handleTouchMove,
      onTouchEnd: this.handleTouchEnd
    } : {
      onMouseDown: this.handleMouseDown,
      onMouseMove: this.handleMouseMove,
      onMouseUp: this.handleMouseUp
    };
    return React.createElement('div', {
      className: this.getClasesLienzo(),
      style: style
    }, React.createElement('canvas', _extends({
      id: 'pizarra-canvas',
      width: resolucion.w,
      height: resolucion.h,
      ref: this.canvasRef,
      style: {
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent',
        pointerEvents: "initial"
      }
    }, eventos)));
  };

  return Lienzo;
}(Component), _class.propTypes = {
  colorLapiz: t.string,
  grosorLapiz: t.number,
  colorMarcador: t.string,
  grosorMarcador: t.number,
  alphaMarcador: t.number,
  grosorBorrador: t.number,
  herramienta: t.oneOf([c.HERRAMIENTA_LAPIZ, c.HERRAMIENTA_BORRADOR, c.HERRAMIENTA_MARCADOR]),
  dataURL: t.string,
  resolucion: t.shape({
    w: t.number.isRequired,
    h: t.number.isRequired
  }),
  style: t.object,
  dispatch: t.func // onNotificarCambios: t.func

}, _class.defaultProps = {
  colorLapiz: c.COLOR_LAPIZ_DEFECTO,
  grosorLapiz: c.GROSOR_LAPIZ_DEFECTO,
  colorMarcador: c.COLOR_MARCADOR_DEFECTO,
  grosorMarcador: c.GROSOR_MARCADOR_DEFECTO,
  alphaMarcador: c.ALPHA_MARCADOR_DEFECTO,
  grosorBorrador: c.GROSOR_BORRADOR_DEFECTO,
  herramienta: c.HERRAMIENTA_LAPIZ,
  dataURL: null,
  resolucion: c.RESOLUCION_DEFECTO
}, _temp);
Lienzo = connect(function (state, ownProps) {
  return {
    colorLapiz: getColorLapiz(state),
    grosorLapiz: getGrosorLapiz(state),
    colorMarcador: getColorMarcador(state),
    grosorMarcador: getGrosorMarcador(state),
    alphaMarcador: getAlphaMarcador(state),
    grosorBorrador: getGrosorBorrador(state),
    herramienta: getHerramienta(state),
    dataURL: getDataURL(state)
  };
}, null)(Lienzo);
export default Lienzo;